import React from "react";
import { ValidatorComponent } from "react-material-ui-form-validator";
import SelectSearch from "react-select-search";
import "./style.css";

class InputSelectSearch extends ValidatorComponent {
  render() {
    const { errorMessages, validators, requiredError, value, ...rest } =
      this.props;
    const { isValid } = this.state;
    console.log(value);
    console.log("ini value ya");
    return (
      <div
        className={
          !isValid
            ? "select-search-custom select-search-validator has-error"
            : "select-search-custom select-search-validator"
        }
      >
        <SelectSearch
          value={value}
          {...rest}
          ref={(r) => {
            this.input = r;
          }}
        />
        {this.errorText()}
      </div>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    }

    return (
      <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
        {this.getErrorMessage()}
      </p>
    );
  }
}

export default InputSelectSearch;
